import { Tag } from "primereact/tag";
import { classNames } from "primereact/utils";

import { Icon } from "@/ds";
import { rotuloConflitos } from "../equipe-obra.utils";
import styles from "./equipe-conflitos-tag.module.scss";
import type { ConflitosTagProps } from "./types-equipe-conflitos-tag";

// O ícone vai sem a classe do Prime: o tema dá 4px de margem e o Figma pede 2px (o `gap` da tag).
const ICONE = () => <Icon name="exclamation-triangle" size={10.5} />;

/** Conflitos do profissional com outras obras no período: tag `warn` de 10px com o triângulo de alerta. */
export function ConflitosTagView({ quantidade }: ConflitosTagProps) {
  return (
    <Tag
      severity="warning"
      className={classNames("p-tag-xs", styles.conflitos)}
      icon={ICONE}
      value={rotuloConflitos(quantidade)}
      data-testid="equipe-obra-conflitos-tag"
    />
  );
}
